import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../../client-utils/styled/shouldForwardProp.util.js";
import Box from "../../../../components/atoms/Box/index.js";
import List from "../../../../components/atoms/List/index.js";
import ListItem from "../../../../components/atoms/ListItem/index.js";
import ListItemButton from "../../../../components/atoms/ListItemButton/index.js";
import { coreComponentName } from "../SearchBar.consts.js";
import { QUADRUPLE, TRIPLE } from "../../../../constants/numbers.consts.js";
export const ResultsList = styled(List, {
    name: coreComponentName,
    slot: "ResultsList",
})(({ theme }) => {
    const { borderRadius } = theme.shape;
    return {
        overflow: "hidden",
        paddingTop: 0,
        paddingBottom: 0,
        background: theme.vars.palette.surface.containerHigh,
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    };
});
const StyledResultsListItem = styled(ListItemButton, {
    name: coreComponentName,
    slot: "ResultsListItem",
    shouldForwardProp: shouldForwardProp("selected"),
})(({ theme, selected }) => ({
    background: selected ? theme.vars.palette.surface.containerHighest : "transparent",
}));
export const ResultsListItem = ({ data, index, clearResults, selectedIndex, onClick, isPreviousQuery, onPreviousClick, setQuery, ...props }) => (_jsx(StyledResultsListItem, { ...props, selected: index === selectedIndex, onClick: (e) => {
        if (isPreviousQuery) {
            onPreviousClick?.(data.label);
        }
        else {
            clearResults && data.payload?.(clearResults);
            onClick?.(e);
            setQuery?.();
        }
    } }));
export const ResultsTitle = styled(ListItem, {
    name: coreComponentName,
    slot: "ResultsTitle",
})({
    paddingTop: 0,
    paddingBottom: 0,
});
export const MoreResults = styled(ListItemButton, {
    name: coreComponentName,
    slot: "MoreResults",
})(({ theme }) => ({
    borderTop: `thin solid ${theme.vars.palette.outline.variant}`,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
}));
export const SkeletonWrapper = styled(Box, {
    name: coreComponentName,
    slot: "SkeletonWrapper",
})(({ theme }) => ({
    padding: theme.spacing(TRIPLE),
    paddingBottom: theme.spacing(QUADRUPLE),
}));
